import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {FeatureTypeRequest} from "../../_api/jnbkarta/models/feature-type-request";
import {FeatureTypeRequestMultiple} from "../../_api/jnbkarta/models/feature-type-request-multiple";
import {NetDbApi} from "../../_api/jnbkarta/services/net-db-api";
import {NetDbService} from "../net-db.service";
import { BandelSearchRequest, SearchRequest } from "@app/_api/jnbkarta/models";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: "root",
})
export class NetDbJnbKartaService implements NetDbService {

    constructor(private netDbApiClient: NetDbApi) {}

    public getLastFeatureUpdateNVDB() {
        return this.netDbApiClient.getLastFeatureUpdateNVDB()
    }

    public infoClickInCoordinate(featureTypeRequest: FeatureTypeRequest): Observable<string> {
        return this.netDbApiClient.infoClickInCoordinate({
            body: featureTypeRequest,
        });
    }    

    public infoClickMultiple(featureTypeRequestMultiple: FeatureTypeRequestMultiple): Observable<string> {
        return this.netDbApiClient.infoClickMultiple({
            body: featureTypeRequestMultiple,
        });
    }

    public searchAll(searchObj: SearchRequest): Observable<string> {
        return this.netDbApiClient.search(
            {
                body: searchObj
            }
        )
    }

    public getDescription(metaKey: string): Observable<string> {
        return this.netDbApiClient.getDescription({metaKey: metaKey});
    }

    public bandelSearch(bandelSearchRequest: BandelSearchRequest) {
        return this.netDbApiClient.bandelSearch({
        body: bandelSearchRequest
        })
    }

}
